/**
 * Platform detection utilities for Cordova/Web hybrid application
 * Determines runtime environment (web browser vs Cordova mobile wrapper)
 */

/**
 * Detects if the application is running in a Cordova context
 * @returns true if Cordova is available, false otherwise
 */
export const isCordova = (): boolean => {
  return typeof window !== 'undefined' && window.cordova !== undefined;
};

/**
 * Detects if the application is running in a web browser context
 * @returns true if running in standard browser, false if in Cordova
 */
export const isWeb = (): boolean => {
  return typeof window !== 'undefined' && window.cordova === undefined;
};

/**
 * Gets the current platform identifier for API calls
 * @returns 'web' for browser context, 'cordova' for mobile wrapper
 */
export const getPlatform = (): 'web' | 'cordova' => {
  return isCordova() ? 'cordova' : 'web';
};
